import React, { FunctionComponent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { SearchResultPlan } from "../../../../@types";
import { makePlanLongId, useTranslate } from "../../../../helpers";
import BasePlanCard from "./BasePlanCard";
import URI from "urijs";
import routes from "../../../../app/routes";
import { useHistory } from "react-router";
import { AppContext } from "../../../../app/store";
import englishTranslations from "../../../../translations/en-US.json";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../../../app/contexts/Analytics/types";

interface YearOverYearCompareCardProps {
  dataTestId?: string;
  currentCoverage: SearchResultPlan;
  nextYearCoverage: SearchResultPlan;
}

const YearOverYearCompareCard: FunctionComponent<YearOverYearCompareCardProps> = ({
  currentCoverage,
  nextYearCoverage,
  dataTestId,
}) => {
  const t = useTranslate();
  const history = useHistory();
  const { dispatch } = useContext(AppContext);

  return (
    <BasePlanCard
      header={t("yoy.compare_card.keep_plan")}
      subHeader={t("yoy.compare_card.see_costs")}
      dataTestId={dataTestId}
      footer={
        <Button
          variation="solid"
          onClick={() => {
            const yearOverYearUrl = new URI(routes.yearOverYear);
            yearOverYearUrl.addSearch(
              "plans",
              [currentCoverage, nextYearCoverage].map(plan =>
                makePlanLongId(plan)
              )
            );

            history.push(yearOverYearUrl.toString());
            dispatch({
              type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
              settings: {
                button: {
                  buttonStyle: AnalyticsButtonStyle.PRIMARY,
                  buttonType: AnalyticsButtonType.BUTTON,
                  text: englishTranslations["yoy.compare_card.compare"],
                },
                linkUrl: yearOverYearUrl.toString(),
              },
            });
          }}
        >
          {t("yoy.compare_card.compare")}
        </Button>
      }
    />
  );
};

export default YearOverYearCompareCard;
